import React from "react";
import "./GenericFilterComponent.css";

const GenericFilterComponent = ({ filterConfig }) => {
  return (
  
  <div className="col-md-3">   
  
    <div className="generic-filter-container">
    <span className="filter_name_head">Filters</span>
    <div className="divider"  />

      {filterConfig?.map((item, itemIndex) => (
        <div key={itemIndex} className="generic-filter-section">
          <div className="generic-filter-header">{item?.title}</div>
          {item?.data.map((dataItem, dataIndex) => (
            <div className="form-check gen-form-check">
            <label
              key={dataItem.id || dataIndex}
              className="form-check-label custom_lable_type cursorP generic-checkbox-label"
            >
              <input
                type="checkbox"
                className="generic-checkbox-input form-check-input generic_new_custom_input custom_input_type"
                checked={dataItem.checked || false}
                onChange={() => item?.onClickFilter?.(dataItem)} // Fixed this line
              />
              <div>
              {dataItem.label}
              {dataItem.count && <span>({dataItem.count})</span>}

              </div>
              
            </label>
            </div>
          ))}
        </div>
      ))}
    </div>
    </div>

  );
};

export default GenericFilterComponent;
